import { createFileRoute } from '@tanstack/react-router';
import { SummaryScreen } from '../features/summary/SummaryScreen';
import { RequireAuth } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/summary/$sessionId')({
  component: SummaryRoute,
});

function SummaryRoute(): React.JSX.Element {
  const { sessionId } = Route.useParams();
  return <RequireAuth role="child">{(me) => <SummaryScreen sessionId={sessionId} me={me} />}</RequireAuth>;
}
